import { createSlice } from '@reduxjs/toolkit';
import { MeterLabel, SensorLabel } from '../constants/Types';

export type SensorsFilterState = {
  [SensorLabel.MTS]: boolean,
  [SensorLabel.PCS]: boolean,
  [SensorLabel.LS]: boolean,
  [SensorLabel.ENT]: boolean,
  [SensorLabel.TPS]: boolean,
  [MeterLabel.EM]: boolean,
  [MeterLabel.HM]: boolean,
  [MeterLabel.WM]: boolean,
  [MeterLabel.GM]: boolean,
}

const initialState: SensorsFilterState = {
  [SensorLabel.MTS]: false,
  [SensorLabel.PCS]: false,
  [SensorLabel.LS]: false,
  [SensorLabel.ENT]: false,
  [SensorLabel.TPS]: false,
  [MeterLabel.EM]: false,
  [MeterLabel.HM]: false,
  [MeterLabel.WM]: false,
  [MeterLabel.GM]: false,
};

const sensorsFilterSlice = createSlice({
  name: 'sensorsFilter',
  initialState,
  reducers: {
    updateSensorFilter(
      state: SensorsFilterState,
      action: { payload: { key: string, value: boolean } },
    ) {
      state[action.payload.key] = action.payload.value;
    },
    resetSensorFilter(state: SensorsFilterState) {
      Object.keys(state).forEach((key: string) => {
        state[key] = false;
      });
    },
  },
});

export const { updateSensorFilter, resetSensorFilter } = sensorsFilterSlice.actions;

export default sensorsFilterSlice.reducer;
